import PropTypes from 'prop-types';

import { getOrganisationWorkItemIsLoading } from 'selectors/organisation';
import { OrgSearchArea } from './OrgSearchArea';

/**
 * Activity tab search bar on the org profile: the People bar with the work-item
 * loading state, so the term input locks and the Search Builder runs the search.
 */
export default function OrganisationWorkItemSearchArea(props) {
  return (
    <OrgSearchArea
      {...props}
      loadingSelector={getOrganisationWorkItemIsLoading}
      filterGroup='OrganisationWorkItem'
      location='OrganisationWorkItemsSearch'
    />
  );
}

OrganisationWorkItemSearchArea.propTypes = {
  organisation: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }),
  handleSearch: PropTypes.func.isRequired,
  handleCancel: PropTypes.func,
  loading: PropTypes.bool,
};
